<template>
  <div class="dashboard">
    <!-- 有店铺/认证时显示完整面板 hasShop-->
    <div v-if="hasShop">
      <!-- 第一行：用户信息 + 待办事项 -->
      <el-row :gutter="20" style="margin-top: 4vh;">
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>用户信息</span>
            </div>
            <div class="user-info">
              <el-avatar :src="user.avatar || ''" size="large"></el-avatar>
              <div class="info">
                <div class="role">{{ user.role }}</div>
                <div class="name">{{ user.name }}</div>
              </div>
              <!-- 零售商专属：绑定品牌方按钮 -->
              <div class="user-actions" v-if="userType === 'retailer'">
                <el-button type="primary" plain size="small" @click="bindBrand" v-if="!brandId">
                  绑定品牌方
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>待办事项</span>
            </div>
            <div class="todo-list">
              <div class="todo-item">
                <span>经销商审核</span>
                <el-badge :value="todo.shop_pending" class="item">
                  <el-button size="small" type="primary" plain @click="gotoShopList">
                    待审核
                  </el-button>
                </el-badge>
              </div>
              <div class="todo-item">
                <span>证件审核</span>
                <el-badge :value="todo.card_pending" class="item">
                  <el-button size="small" type="primary" plain @click="gotoCardList">
                    待审核
                  </el-button>
                </el-badge>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 第二行：店铺图表 + 证件图表 -->
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>店铺审核统计</span>
            </div>
            <div ref="shopChart" style="height: 400px;"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>证件审核统计</span>
            </div>
            <div ref="cardChart" style="height: 400px;"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 无店铺/认证时的提示 -->
    <!-- 无店铺/认证时的提示 -->
<div v-else>
  <!-- 状态1：已提交店铺申请，审核中 -->
  <div v-if="shopType" class="no-shop-tip">
    <el-empty description="店铺审核中">
      <div style="margin-top: 8px; color: #606266; font-size: 14px;">
        您的店铺申请已提交，请耐心等待审核
      </div>
      <div style="margin-top: 4px; color: #909399; font-size: 13px;">
        类型：{{ shopType }}
      </div>
    </el-empty>
  </div>

  <!-- 状态2：未申请店铺，显示注册/认证入口 -->
  <div v-else>
    <!-- 零售商：显示认证提示 + 绑定品牌按钮 -->
    <div v-if="userType === 'retailer'" class="no-shop-tip">
      <el-empty description="暂无认证">
        <el-button type="primary" @click="goAuth">前往认证</el-button>
      </el-empty>
      <div style="text-align: center; margin-top: 20px;">
        <el-button type="warning" plain @click="bindBrand">绑定品牌方</el-button>
      </div>
      <p style="text-align: center; color: #909399; font-size: 14px; margin-top: 10px;">
        请先完成认证，再绑定品牌方体验完整权益
      </p>
    </div>

    <!-- 批发商：显示注册店铺提示 -->
    <div v-if="userType === 'wholesaler'" class="no-shop-tip">
      <el-empty description="暂无店铺">
        <el-button type="primary" @click="goRegister">立即注册店铺</el-button>
      </el-empty>
      <p style="text-align: center; color: #909399; font-size: 14px; margin-top: -10px;">
        请先注册店铺体验完整权益
      </p>
    </div>
  </div>
</div>

    <!-- ========== 绑定品牌方弹窗 ========== -->
    <el-dialog
      title="绑定品牌方"
      :visible.sync="bindDialogVisible"
      width="560px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <div v-loading="brandLoading" element-loading-text="加载品牌列表中...">
        <!-- 空状态 -->
        <div v-if="!brandLoading && brandList.length === 0" class="brand-empty">
          <el-empty description="暂无品牌方可供选择" :image-size="80"></el-empty>
        </div>

        <!-- 品牌列表 -->
        <el-radio-group
          v-else
          v-model="selectedBrandId"
          class="brand-radio-group"
          @change="handleBrandSelect"
        >
          <div
            v-for="brand in brandList"
            :key="brand.id"
            class="brand-item"
            :class="{ 'is-active': selectedBrandId === brand.id }"
            @click="selectedBrandId = brand.id; handleBrandSelect(brand)"
          >
            <el-radio :label="brand.id" :key="brand.id">
              <span class="brand-name">{{ brand.sh_name }}</span>
              <span class="brand-id">ID: {{ brand.id }}</span>
            </el-radio>
          </div>
        </el-radio-group>

        <!-- 当前选中提示 -->
        <div v-if="selectedBrand" class="selected-tip">
          <i class="el-icon-check"></i>
          已选择：<strong>{{ selectedBrand.sh_name }}</strong>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="bindLoading"
          :disabled="!selectedBrandId || brandList.length === 0"
          @click="submitBindBrand"
        >
          {{ bindLoading ? '绑定中...' : '确认绑定' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import * as echarts from 'echarts'
import axios from 'axios'
import Cookie from 'js-cookie'

const token = Cookie.get('token')
const Request = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})

export default {
  name: 'Dashboard',
  data () {
    return {
      hasShop: true, // 是否有店铺/认证
      userType: '', // 用户类型
      user: {
        name: '',
        avatar: 'https://caixiao.lianglianyn.com/index/upload/02_dian/6a29013d6bfba_1781072189.jpg',
        role: '超级管理员'
      },
      todo: { shop_pending: 0, card_pending: 0 },
      shopStats: { pending: 0, approved: 0, rejected: 0 },
      cardStats: { pending: 0, approved: 0, rejected: 0 },
      shopChartInstance: null,
      cardChartInstance: null,
      brandId: '',
      // ---------- 绑定品牌方弹窗相关 ----------
      bindDialogVisible: false,
      brandList: [], // 品牌列表
      selectedBrandId: null, // 选中的品牌ID
      selectedBrand: null, // 选中的品牌对象 { id, sh_name }
      brandLoading: false,
      bindLoading: false,
      shopType: ''
    }
  },
  mounted () {
    // 读取用户信息
    const shId = localStorage.getItem('sh_id')
    this.hasShop = shId && shId !== 'null' && shId !== 'undefined' && shId.trim() !== '' && shId > 0
    this.userType = localStorage.getItem('user_type') || ''
    this.user.name = localStorage.getItem('user_name') || ''
    const brandId = localStorage.getItem('brand_id')
    console.log(brandId)
    this.brandId = brandId && brandId !== 'null' && brandId !== 'undefined' && brandId.trim() !== ''
    // 只有有店铺/认证时才加载数据
    this.getshop()
    if (this.hasShop) {
      this.fetchData()
    }
  },
  beforeDestroy () {
    if (this.shopChartInstance) {
      this.shopChartInstance.dispose()
      this.shopChartInstance = null
    }
    if (this.cardChartInstance) {
      this.cardChartInstance.dispose()
      this.cardChartInstance = null
    }
  },
  methods: {
    async getshop () {
      const response = await request.post('sh/sh_jiben_list.php', { user_id: localStorage.getItem('user_id') })
      console.log(response)
      if (response.code === 0) {
        this.shopType = response.list[0].sh_type || ''
      }
    },
    // ---------- 原有方法 ----------
    async fetchData () {
      const response = await Request.post('https://caixiao.lianglianyn.com/index/home_jiben_list.php')
      if (response.data.code === 0) {
        const data = response.data
        this.todo = data.todo
        this.shopStats = data.shop_chart
        this.cardStats = data.card_chart
        this.$nextTick(() => {
          this.initCharts()
        })
      }
    },
    initCharts () {
      // ---- 店铺扇形图 ----
      if (!this.shopChartInstance) {
        this.shopChartInstance = echarts.init(this.$refs.shopChart)
      }
      const shopPieData = [
        { name: '待审核', value: this.shopStats.pending },
        { name: '已审核', value: this.shopStats.approved },
        { name: '已拒绝', value: this.shopStats.rejected }
      ]
      this.shopChartInstance.setOption({
        tooltip: { trigger: 'item', formatter: '{a} <br/>{b}: {c} ({d}%)' },
        legend: { orient: 'vertical', left: 'left' },
        series: [
          {
            name: '店铺审核状态',
            type: 'pie',
            radius: '50%',
            data: shopPieData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}\n{d}%'
            }
          }
        ]
      })

      // ---- 证件扇形图 ----
      if (!this.cardChartInstance) {
        this.cardChartInstance = echarts.init(this.$refs.cardChart)
      }
      const cardPieData = [
        { name: '待审核', value: this.cardStats.pending },
        { name: '已审核', value: this.cardStats.approved },
        { name: '已拒绝', value: this.cardStats.rejected }
      ]
      this.cardChartInstance.setOption({
        tooltip: { trigger: 'item', formatter: '{a} <br/>{b}: {c} ({d}%)' },
        legend: { orient: 'vertical', left: 'left' },
        series: [
          {
            name: '证件审核状态',
            type: 'pie',
            radius: '50%',
            data: cardPieData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}\n{d}%'
            }
          }
        ]
      })
    },
    gotoShopList () {
      this.$router.push('/system/user')
    },
    gotoCardList () {
      this.$router.push('/system/menu')
    },
    goRegister () {
      this.$router.push('/system/dept')
    },
    goAuth () {
      this.$router.push('/system/deptjx')
    },

    // ---------- 绑定品牌方（统一入口） ----------
    bindBrand () {
      // 检查是否已认证（即是否有sh_id）
      // if (!this.hasShop) {
      //   this.$message.warning('请先完成认证再绑定品牌方')
      //   return
      // }
      // 已认证 → 打开弹窗
      this.openBindDialog()
    },

    // ---------- 打开绑定弹窗 ----------
    async openBindDialog () {
      // 重置状态
      this.selectedBrandId = null
      this.selectedBrand = null
      this.brandList = []
      this.bindDialogVisible = true

      // 加载品牌列表
      await this.fetchBrandList()
    },

    // ---------- 获取品牌方列表 ----------
    async fetchBrandList () {
      const shId = localStorage.getItem('sh_id')
      if (!shId) {
        this.$message.error('未获取到经销商信息，请重新登录')
        this.brandLoading = false
        return
      }

      this.brandLoading = true
      try {
        const response = await Request.post('https://caixiao.lianglianyn.com/admin/brand_list.php', {
          a: 'lists',
          page: '1',
          page_size: '20'
        })
        const res = response.data
        if (res.code === '0' || res.code === 0) {
          this.brandList = res.data || []
          if (this.brandList.length === 0) {
            this.$message.info('暂无品牌方可供绑定')
          }
        } else {
          this.$message.error(res.msg || '获取品牌列表失败')
          this.brandList = []
        }
      } catch (error) {
        console.error('获取品牌列表失败:', error)
        this.$message.error('网络异常，请稍后重试')
        this.brandList = []
      } finally {
        this.brandLoading = false
      }
    },

    // ---------- 选择品牌 ----------
    handleBrandSelect (brand) {
      if (brand) {
        this.selectedBrand = brand
      } else {
        // 通过 ID 查找
        const found = this.brandList.find(b => String(b.id) === String(this.selectedBrandId))
        this.selectedBrand = found || null
      }
    },

    // ---------- 提交绑定 ----------
    async submitBindBrand () {
      if (!this.selectedBrandId) {
        this.$message.warning('请选择一个品牌')
        return
      }

      const brand = this.brandList.find(b => String(b.id) === String(this.selectedBrandId))
      if (!brand) {
        this.$message.error('所选品牌不存在，请重新选择')
        return
      }

      const shId = localStorage.getItem('sh_id')
      if (!shId) {
        this.$message.error('未获取到经销商信息，请重新登录')
        return
      }

      this.bindLoading = true
      try {
        const response = await Request.post('https://caixiao.lianglianyn.com/admin/brand_list.php', {
          a: 'brandBind',
          brand_id: String(brand.id),
          brand_name: brand.sh_name,
          jx_id: String(shId),
          sh_main: shId
        })
        const res = response.data
        if (res.code === '0' || res.code === 0) {
          this.$message.success(res.res || '绑定成功')
          // 关闭弹窗
          this.bindDialogVisible = false
          // 刷新数据（更新待办、图表等）
          this.fetchData()
        } else {
          this.$message.error(res.msg || res.res || '绑定失败，请稍后重试')
        }
      } catch (error) {
        console.error('绑定品牌失败:', error)
        this.$message.error('网络异常，请稍后重试')
      } finally {
        this.bindLoading = false
      }
    },

    // ---------- 弹窗关闭回调 ----------
    handleDialogClose () {
      // 重置状态
      this.brandLoading = false
      this.bindLoading = false
      this.selectedBrandId = null
      this.selectedBrand = null
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard {
  padding: 20px;

  .box-card {
    height: 100%;
  }

  .user-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;

    .info {
      margin-left: 20px;
      .name {
        font-size: 18px;
        font-weight: bold;
      }
      .role {
        color: #909399;
        font-size: 14px;
      }
    }

    .user-actions {
      margin-left: auto;
      display: flex;
      gap: 10px;
      align-items: center;
    }
  }

  .todo-list {
    display: flex;
    justify-content: space-around;
    .todo-item {
      display: flex;
      align-items: center;
      gap: 10px;
      span {
        font-size: 14px;
        color: #606266;
      }
    }
  }

  // 无店铺/认证提示样式
  .no-shop-tip {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    padding: 40px 20px;
    background: #fafafa;
    border-radius: 8px;
    .el-empty {
      .el-empty__image {
        width: 120px;
      }
      .el-empty__description {
        font-size: 16px;
        color: #606266;
        margin-top: 10px;
      }
    }
  }

  // ---------- 绑定品牌方弹窗样式 ----------
  .brand-radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding: 4px 0;

    .brand-item {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      border-radius: 8px;
      border: 1px solid #e4e7ed;
      transition: all 0.25s ease;
      cursor: pointer;

      &:hover {
        border-color: #409eff;
        background-color: #f5f7fa;
      }

      &.is-active {
        border-color: #409eff;
        background-color: #ecf5ff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }

      .el-radio {
        display: flex;
        align-items: center;
        width: 100%;
        margin-right: 0;
        height: auto;

        .el-radio__label {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex: 1;
          padding-left: 8px;
          font-size: 15px;

          .brand-name {
            font-weight: 500;
            color: #303133;
          }

          .brand-id {
            font-size: 12px;
            color: #909399;
            margin-left: 16px;
          }
        }
      }
    }
  }

  .selected-tip {
    margin-top: 16px;
    padding: 10px 16px;
    background-color: #f0f9eb;
    border-radius: 6px;
    color: #67c23a;
    font-size: 14px;

    i {
      margin-right: 6px;
    }

    strong {
      color: #303133;
    }
  }

  .brand-empty {
    padding: 20px 0;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
